<template>
  <div style="width: 100%; height: 100vh; overflow: hiddle">
    <iframe :src="iframeUrl" width="100%" height="100%" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
    data() {
        return {
            iframeUrl: "https://work.yingyuchat.com/chatIndex?kefu_id=rnd600&ent_id=5084&lang=cn"
        }
    }
}
</script>

<style>

</style>